export default {
   'Search': 'Suche',
   'Users': 'Nutzer',
   'Email': 'E-Mail',
   'Phone Number': 'Telefonnummer',
   'Address': 'Adresse',
   'Company login': 'login',
    
 /****************** Navbar *************/
    'Logout': 'abmelden',
    'Profile': 'Profil',
    'Invoices':'Rechnungen',
 /****************** Dashboard Datatable ***********/
   'Title': 'Name',
   'Version': 'Version',
   'Module Slug': 'Modul',
   'Progress': 'Fortschritt',
   'Attempted on': 'am',
   'Score':'Punkte',
   'Your Quizes':'Quiz',
   'Launch':'Start',
   'Jump To Quiz': 'Zum Test springen',
   'Rows per page': 'Einträge per Seite',
 /****************** Users ***********/
    'Name': 'Name',
    'Actions': 'Aktionen',
    'Image' : 'Bild',
    'Salutation': 'Anrede',
    'Invite Users': 'Nutzer einladen',
     'Date of birth': 'Geburtsdatum',
     'All cards': 'alle Karten',
     'Card added successfully':'Karte erfolgreich hinzugefügt',
     'Remove' :'entfernen',
     'User Profile': 'Nutzer Profil',
     'All Cards': 'Alle Kurse',
     'Add Card' : 'Kurs hinzufügen',
     'Primary': 'Primäre Farbe',
     'Are you sure want to remove?': 'Wirklich entfernen?',
     'Subscribe' : 'teilnehmen',
     'Are you sure you want to purchase?':'Jetzt kaufen?',
     'Yes':'Ja',
     'No':'Nein',
     'You dont seem to have a card added to your profile':'Keine Zahlungsart hinterlegt',
     'Go to profile':'Kreditkarte hinterlegen',
 /****************** Courses ***********/
    'Filters':'Filter',
    'Details': 'ZUM MODUL',
    'Purchased': 'gekauft',
    'Included' : 'inkl.',
    'What Will you Learn?': 'Lerninhalte',
    'Requirements' : 'Voraussetzungen',
    'Description' : 'Beschreibung',
    'PLAY NOW': 'jetzt starten',
    'Language': 'Sprache',
   'Close': 'Schließen',
   'Upload': 'Hochladen',
   'Submit': 'Absenden',
   'User csv file': 'Nutzer CSV Datei',
   'Module name here': 'Hier Kursnamen eintragen',
   'Subscription': 'Abo',
   'Languages': 'Sprachen',
   'Module': 'Modul',
   'Subject': 'Titel',
   'Body': 'Nachricht',
   'Send copy to myself' : 'Eine Kopie an mich senden',
   'Contact us': 'Nimm Kontakt auf',
   'Status': 'Status',
   'Join date': 'Beitrittsdatum',
   'Change status': 'Status ändern',
   'Active': 'aktiv',
   'active': 'aktiv',
   'Inactive':'inaktiv',
   'inactive':'inaktiv',
   'disable': 'deaktivieren',
   'pending': 'ausstehend',
   'Pending': 'ausstehend',
   'Place of birth': 'Geburtsort',
   'Subscribed':'eingeschrieben',
   'Unsubscribed':'nicht eingeschrieben',
   'English':'Englisch',
   'German':'Deutsch',
   'User updated successfully': 'Nutzer erfolgreich aktualisiert',
   'User created successfully': 'Nutzer erfolgreich erstellt',

   'Modules': 'Module',
   'Your Modules': 'Deine Module',

   'No modules found': 'Keine Module gefunden',
   'Course':'Kurse',
   'Your attempted modules': 'Deine Modul Versuche',
   'No data found': 'keine Daten gefunden',
   'Time Spent' : 'verbrachte Zeit',
   'From': 'vom',
   'To': 'bis zum',
   'Play':'abspielen',  
   'Your sessions': 'Deine Sessions',
   'Your attempts': 'Deine Versuche',    
   'Settings': 'Einstellungen',
   'View': 'ansehen',
   'Roles': 'Rollen',
   'Group': 'Gruppe',   
   'Comment (optional)': 'Kommentar (optional)',
   'Due date': 'gültig bis',
   'Select file': 'Dokument aussuchen',
   'Days until': 'Tage gültig',
   'Template' : 'Vorlage',
   'Update': 'Update',
   'Edit': 'Editieren', 
   'Uploaded by': 'hochgeladen von',  
   'Uploaded on': 'hochgeladen am',
   'Type':'Typ',
   'Action':'Aktion',
   'Stage 1': 'Bereich 1',
   'Stage 2': 'Bereich 2',
   'Set Name': 'Name',
   'Show next': 'zeige die nächsten x Tage',
   'Show from':'zeige die darauffolgenden nächsten x Tage',   
   'Name is required': 'Name wird benötigt',
   'Invalid Email address': 'Keine gültige E-Mail Adresse',
   'Phone Number is required': 'Es wird eine Telefonnummer benötigt',
   'Salutation is required':'Ansprache wird benötigt',
   'Address is required': 'Adresse wird benötigt',
   'Group admin is required':'Gruppen Admin muss erstellt werden',
   'Groups are required': 'Gruppen werden benötigt',
   'Status is required': 'Status wird benötigt',
   'Mr': 'Herr',
   'Mrs':'Frau',  
   'Set Filter':'Filter setzen',
   'Location':'Ort',
   'Procedure': 'Prozedur',
   'Class':'Klasse',
   'Maker':'Hersteller',
   'Serial maker': 'Hersteller',
   'Stock':'Lager',
   'Good until date': 'gültig bis',
   'Equipment':'Ausstattung',
   'Number in stock': 'Lagerbestand',
   'Location is required':'Der Ort wird benötigt',
   'Class is required':'Klasse wird benötigt',
   'Maker is required':'Hersteller wird benötigt',
   'Number in stock is required':'Lagerbestand wird benötigt',
   'Goods until date is required':'Gültig bis wird benötigt',
   'Procedure is required':'Prozedur wird benötigt',
   'Description is required':'Beschreibung wird benötigt',
   'Equipment created successfully':'Equipment erfolgreich angelegt',
   'Equipment updated successfully':'Equipment erfolgreich ge-updated',
   'Group name': 'Gruppen-Name',
   'Group admins': 'Gruppen Administratoren',
   'Group name is required':'Gruppen-Name wird benötigt',
   'Users are required': 'Nutzer werden benötigt',
   'Course are required':'Kurse werden benötigt',
   'Company settings': 'Administration des Accounts',
   'Company Color': 'Firmen Primärfarbe',
   'Session login time': 'Login Zeit',
   'Primary color is required':'Farbe kann nicht leer sein',
   'Company settings updated successfully':'Firmeneinstellungen erfolgreich geändert',
   'Intellectual Property Rights':'Rechte an geistigen Eigentum',
   'Unless otherwise indicated, the Site and all source code, database, functionality, software, website designs, audio, video, text, photographs, and other learning material on the Site (collectively, the “Content”) and the trademarks, service marks, and logos contained therein (collectively, the “Marks”) are protected by copyright and trademark laws and various other intellectual property rights and unfair competition laws of Germany, foreign jurisdictions, and international conventions.': 'Sofern nicht anders angegeben, sind die Website und alle Quellcodes, Datenbanken, Funktionen, Software, Website-Designs, Audio-, Video-, Text-, Foto- und sonstigen Lernmaterialien auf der Website (zusammen der „Inhalt“) sowie die Marken, Dienstleistungsmarken, und darin enthaltene Logos (zusammen die „Marken“)  durch Urheber- und Markenrechte sowie verschiedene durch andere Rechte an geistigem Eigentum und an den Gesetzen gegen unlauteren Wettbewerb in Deutschland, ausländischen Gerichtsbarkeiten und internationalen Konventionen geschützt.',
   'I accept this (required)': 'Ich akzeptiere das (erforderlich)',
   'Please subscribe to a course': 'Bitte melden Sie sich zu einem Kurs an',
   'Your score': 'Erreichte Punkte',
   'Max Score' : 'Maximale Punkte',
   'Time taken':'Verbrachte Zeit',
   'Pass Score':'Benötigte Punkte',
   'No subscribed courses found':'Sie sind noch keinem Kurs beigetreten',   
   'Role is required':'Rolle wird benötigt',
   'Confirm Password is required':'Bitte bestätigen Sie das Passwort',
   'Password must contain 1 Uppercase, 1 Lowercase, 1 Numeric and 1 special character': 'Das Passwort muss eine Länge von 8 Zeichen haben und mindestens 1 Großbuchstaben, 1 Kleinbuchstaben, 1 Zahl und 1 Sonderzeichen enthalten.',
   'Password must be at least 8 characters long': 'Das Passwort muss mindestens 8 Zeichen lang sein',
   'Confirm Password must be at least 8 characters long' : 'Das Passwort muss mindestens 8 Zeichen lang sein',
   'Confirm Password must contain 1 Uppercase, 1 Lowercase, 1 Numeric and 1 special character': 'Das Passwort muss eine Länge von 8 Zeichen haben und mindestens 1 Großbuchstaben, 1 Kleinbuchstaben, 1 Zahl und 1 Sonderzeichen enthalten.',   
   'Query successfully sent': 'Erfolgreich gesendet',
   'Learning Center': 'Learning Center',
   'Courses': 'Kurse',
   'Powered by Evaluation Experts': 'Powered by Evaluation Experts',
   'Check':'filtern',
   'Clear': 'löschen',
   'Groups': 'Gruppen',
   'Inbox': 'Inbox',
   'No data available': 'Keine Einträge gefunden.',
   'Company color': 'Firmen Primärfarbe',
   'Learning material': 'Lernmaterial',
   'Search learning material': 'Lernmaterial durchsuchen',
   'Learning material updated successfully':'erfolgreich akutalisiert',
   'Learning material are required':'Lernmaterial wird benötigt',
   'Learning material name':'Lernmaterial Name',
   'Update Password': 'Passwort aktualisieren',
   'This password reset token is invalid': 'Bitte kontaktieren Sie ihren Admin, Ihr Link ist abgelaufen.',
   'Password is required':'Passwort ist notwendig',   
   'Accept & Continue': 'Akzeptieren und weiter',
   'Due days is required':'',
   'Learn NDT': 'Learn NDT',
   'Username':'Name',
   'Password':'Passwort',
   'Forgot password': 'Passwort vergessen',
   'Register':'Registrieren',
   'Login':'Login',   
   'Username is required': 'Name wird benötigt',
   'Phone is required':'Telefonnummer wird benötigt',
   'User registeration successfully': 'Nutzer erfolgreich registriert',
   'Company Admin Login': 'Login',
   'Go to Login': 'zum Login',
   'Send link':'Link senden',
   'No user documents':'keine Nutzer-Dokumente',
   'User documents':'Nutzer-Dokumente',
   'Update user documents' : 'Nutzer-Dokument aktualisieren',
   'Edit user documents': 'Nutzer-Dokumente editieren',
   'Module details': 'Modul Details',
  'passed':'bestanden',
   'failed':'nicht bestanden',  
   'of':'aus',
   'Create user documents':'Nutzer Dokument erstellen',
   'Passwords must match': 'Wiederholen Sie aus Sicherheitsgründen das oben genannte Passwort.',
   'attempted': 'versucht',
   'Progress & Attempts': 'Fortschritt & Versuche',
   'Attempted': 'versucht',
   'Attempts': 'Versuche',
   'Save': 'speichern',
   'Details new': 'öffnen',
   'Profile updated successfully': 'Profil erfolgreich aktualisiert',
   'User document name': 'Name des Dokuments',
   'Group created successfully': 'Gruppe erfolgreich erstellt',
   'Group updated successfully': 'Gruppe erfolgreich aktualisiert',
   'User document updated successfully':'Nutzer Document erfolgreich aktualisiert',
   'Registration status changed successfully': 'Status erfolgreich aktualisiert',
   'Write to Company Representative': 'Ich habe eine interne Frage',
   'Welcome to the learning-material section. After passing a course you will see additional learn-material appear here.':'Herzlich willkommen im Bereich Lernmaterial. Sobald Sie einen Kurs erfolgreich absolviert haben, können Sie die Lernmaterialien hier erneut nutzen.',
   'No Learning material found':'Es wurde kein Lernmaterial gefunden.',
   'OK':'OK',
   'Cancel': 'abbrechen',
   'Body is required':'Nachricht wird benötigt.',
   'Subject is required':'Titel wird benötigt',
   'Undefined':'Allgemein',
   'Copyright legal notice':'Copyright',
   'Please upload a file':'Bitte wählen Sie eine gültige Datei aus.',
   'The value must be an integer number':'Bitte tragen Sie eine Telefonnummer ein.',
   'Date is required': 'Datum wird benötigt',
   'Session minutes is required':'Minuten werden benötigt',
   '& others':'& weitere',
   'Continue':'WEITER',
   'All':'Alle',
   'Confirm Password': 'Passwort bestätigen',
   'Reset your Password':'Passwort zurücksetzen',
};
